<div class="text-xl flex justify-between text-gray-700 font-bold mb-4"> @if (!assignPermission) {
  Perfil
} @else {
  <div>
  Gerenciar permissões do
  <span class="capitalize">{{ item.descricao }}</span>
  </div>
}
  @if (assignPermission) {
    <button class="btn-icon" (click)="backProfile()">
      <mat-icon>keyboard_return</mat-icon>
    </button>
  }</div>
<div>
  @if(!assignPermission){
  @if (checkPermission('criar')) {
    <mat-card class="card-style flex w-full flex-row items-center" style="flex-direction: row !important; align-items: center !important; justify-content: space-around !important;">
      <profile-create class="w-11/12" (responseCreate)="uploadList('new')" />
    <button
      class="btn-icon"
      (click)="getTypeContact()"
    >
      <mat-icon>replay</mat-icon>
    </button>
    </mat-card>
  }
  }
  @if (assignPermission) {
    <assign-permission [profile]="item" />
  } @else {
  <div class="mt-4">
<!--    @if (checkPermission('pesquisar-paginado')) {-->
<!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
<!--    }-->
    <div>

      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editContact($event)"
            (deleteItem)="deleteContact($event)"
            (managerItem)="editPermission($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
  }
</div>
